<template>
  <Modal
    v-model="visible"
    title="选择保险公司"
    width="550"
    class="my-modal-form top"
    :mask-closable="false"
    :footer-hide="true"
  >
    <Form
      v-if="visible"
      ref="form"
      :model="formData"
      class="page-form less"
      :label-width="90"
    >
      <FormItem class="full" prop="companyType" label="公司性质" :rules="$units.formRule.required('请选择')">
        <Select v-model="formData.companyType" @on-change="changeCompany" clearable>
          <Option value="1">总公司</Option>
          <Option value="2">分公司</Option>
        </Select>
      </FormItem>

      <FormItem
        v-if="formData.companyType == 2"
        class="full"
        prop="companyType"
        label="所属总公司"
        :rules="$units.formRule.arrRequired('请选择')"
      >
        <Select
          v-model="formData.parentChannelIds"
          @on-change="changeParentCompany"
          filterable
          clearable
        >
          <Option
            :value="item.id"
            v-for="item in parentCompanyList"
            :key="item.id"
            >{{ item.fullName }}</Option
          >
        </Select>
      </FormItem>

      <FormItem
        v-if="
          formData.companyType == 1 ||
          !formData.companyType ||
          formData.companyType == 2
        "
        class="full"
        prop="companyIds"
        label="保险公司"
        :rules="$units.formRule.arrRequired('请选择')"
        key="companyType"
      >
        <Select
          v-model="formData.companyIds"
          :multiple="true"
          :max-tag-count="2"
          filterable
          clearable
        >
          <Option :value="item.id" v-for="item in companyList" :key="item.id">{{
            item.fullName
          }}</Option>
        </Select>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer footer-btn-box">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save">确认</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  props: ["getCompanyList"],
  data() {
    return {
      formData: {},
      visible: false,
      parentCompanyList: [], //所属总公司
      companyList: [], //保险公司
    };
  },
  methods: {
    async open() {
      this.formData = {
        companyIds: [],
        parentChannelIds: [],
        companyType:'1'
      };
      this.visible = true;
      this.companyList = await this.queryCompany();
    },

    // 查询公司
    queryCompany() {
      return this.$http({
        url: "/buz/insuranceCompany/queryAdd",
        type: "POST",
        data: {
          companyType: 1,
          pageNo:1,
          pageSize:9999
        },
      }).then((res) => {
        return res.data
      });
    },
    // 查询所有总公司
    queryCompanyAll() {
      return this.$http({
        url: "/buz/insuranceCompany/read/all",
        type: "POST",
        data: {
          companyType: 1,
        },
      }).then((res) => {
        return res.data
      });
    },

    // 切换公司性质
    async changeCompany(value) {
      this.formData.companyIds = [];
      this.formData.parentChannelIds = [];
      if (value == 1) {
        this.companyList = await this.queryCompany();
      } else {
        this.companyList = [];
        this.parentCompanyList = await this.queryCompanyAll();
      }
    },

    // 选中所属总公司
    changeParentCompany(value) {
      this.$http({
        url: "/buz/insuranceCompany/queryAdd",
        type: "POST",
        data: {
          companyType: "2",
          parentId: value,          
          pageNo:1,
          pageSize:9999
        },
      }).then((res) => {
        this.companyList = res.data;
      });
    },

    save() {
      this.$refs.form.validate().then((isok) => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        let data = {
          companyIds: formData.companyIds,
        };
        this.$http({
          url: "/buz/merchantCompanyJoin/add",
          type: "POST",
          data,
          apiPermissionCode:'pro_4_1'
        }).then((res) => {
          this.$notice.success("导入成功");
          this.getCompanyList();
          this.visible = false;
        });
      });
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/ .ivu-modal-header-inner {
  font-size: 14px;
}
/deep/ .ivu-modal-header {
  height: 40px;
  padding-left: 20px;
}
/deep/ .ivu-modal-close .ivu-icon-ios-close {
  font-size: 30px;
}
/deep/ .ivu-modal-body {
  padding-top: 20px !important;
  padding-bottom: 0px !important;
}
.page-form {
  /deep/ .ivu-form-item-content {
    display: flex;
    align-items: center;
  }
  .tip-icon {
    margin-left: 6px;
    width: 15px;
    height: 15px;
    border-radius: 15px;
    background: transparent;
    border: 1px solid #ccc;
    color: #ccc;
    display: inline-block;
    text-align: center;
    line-height: 14px;
    font-size: 14px;
    cursor: pointer;
    top: 50%;
  }
  .tip-icon:hover + .pop-tip {
    opacity: 0.9;
    z-index: 1;
    display: block;
  }
  .pop-tip {
    position: absolute;
    top: 35px;
    right: -4px;
    padding: 0px 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: #444444;
    display: none;
    border-radius: 4px;
    span {
      font-size: 12px;
      font-weight: 500;
      color: #fff;
    }
    .arrow {
      position: absolute;
      width: 12px;
      height: 12px;
      background-color: #444444;
      opacity: 0.9;
      top: -4px;
      right: 5px;
      transform: rotateZ(135deg);
    }
  }
  .label {
    position: relative;
    .tip-icon {
      margin-left: 6px;
      width: 15px;
      height: 15px;
      border-radius: 15px;
      background: transparent;
      border: 1px solid #ccc;
      color: #ccc;
      display: inline-block;
      text-align: center;
      line-height: 14px;
      font-size: 14px;
      cursor: pointer;
      top: 50%;
    }
    .tip-icon:hover + .pop-tip {
      opacity: 0.9;
      z-index: 1;
      display: block;
    }
    .pop-tip {
      position: absolute;
      width: 152px;
      top: 22px;
      right: -1px;
      padding: 9px 10px;
      display: flex;
      flex-direction: column;
      background-color: #444444;
      display: none;
      border-radius: 4px;
      span {
        font-size: 12px;
        font-weight: 500;
        color: #fff;
      }
      .arrow {
        position: absolute;
        width: 12px;
        height: 12px;
        background-color: #444444;
        opacity: 0.9;
        top: -4px;
        right: 3px;
        transform: rotateZ(135deg);
      }
    }
  }
}
/deep/ {
  .ivu-modal-body {
    padding-top: 0;
  }
}
.info-text {
  font-size: 12px;
  line-height: 1.5;
  padding-top: 5px;
  color: #ccc;
}
.product-title {
  margin-right: 15px;
  font-size: 12px;
}
.select-product-btn {
  width: 60px;
  height: 25px;
  line-height: 25px;
  margin-top: 2px;
}
</style>